import { render, staticRenderFns } from "./CardEventRecord.vue?vue&type=template&id=02e0ae9b&scoped=true&"
import script from "./CardEventRecord.vue?vue&type=script&lang=js&"
export * from "./CardEventRecord.vue?vue&type=script&lang=js&"
import style0 from "./CardEventRecord.vue?vue&type=style&index=0&id=02e0ae9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e0ae9b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VAvatar,VBtn})
